(() => {
  const init = (root) => {
    if (root.dataset.fcpInitialized === 'true') return;
    root.dataset.fcpInitialized = 'true';

    const slides = Array.from(root.querySelectorAll('[data-fcp-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-fcp-thumb]'));
    const counter = root.querySelector('[data-fcp-current]');
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.hidden = false;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === active;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-selected', String(selected));
      });
      if (counter) counter.textContent = String(active + 1);
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    root.querySelector('[data-fcp-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-fcp-next]')?.addEventListener('click', () => show(active + 1));

    root.querySelectorAll('[data-fcp-tabs]').forEach((tabs) => {
      const buttons = Array.from(tabs.querySelectorAll('[data-fcp-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[data-fcp-panel]'));
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.fcpPanel !== button.dataset.fcpTab; });
      }));
    });

    const benefitsButton = root.querySelector('[data-fcp-benefits-toggle]');
    const benefits = root.querySelector('[data-fcp-benefits]');
    benefitsButton?.addEventListener('click', () => {
      const open = benefitsButton.getAttribute('aria-expanded') === 'true';
      benefitsButton.setAttribute('aria-expanded', String(!open));
      benefitsButton.textContent = open ? 'Ver benefícios +' : 'Ocultar benefícios −';
      if (benefits) benefits.hidden = open;
    });

    const ingredientsCarousel = root.querySelector('[data-fcp-ingredients-carousel]');
    if (ingredientsCarousel) {
      const track = ingredientsCarousel.querySelector('[data-fcp-ingredients-track]');
      const cards = Array.from(ingredientsCarousel.querySelectorAll('.fcp-ingredients__card'));
      const previous = ingredientsCarousel.querySelector('[data-fcp-ingredients-prev]');
      const next = ingredientsCarousel.querySelector('[data-fcp-ingredients-next]');
      const pages = ingredientsCarousel.querySelector('[data-fcp-ingredients-pages]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activePage = 0;
      let pageButtons = [];
      let scrollFrame = 0;

      const cardsPerPage = () => window.matchMedia('(min-width: 1025px)').matches ? 4 : 1;
      const pageCount = () => Math.ceil(cards.length / cardsPerPage());
      const paintActivePage = (page) => {
        activePage = Math.max(0, Math.min(page, pageCount() - 1));
        pageButtons.forEach((button, index) => button.setAttribute('aria-current', String(index === activePage)));
        if (previous) previous.disabled = activePage === 0;
        if (next) next.disabled = activePage === pageCount() - 1;
      };
      const goToPage = (page, smooth = true) => {
        const destination = Math.max(0, Math.min(page, pageCount() - 1));
        const targetIndex = Math.min(destination * cardsPerPage(), cards.length - 1);
        const target = cards[targetIndex];
        if (!track || !target) return;
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto',
        });
        paintActivePage(destination);
      };
      const renderPages = () => {
        if (!pages) return;
        pages.replaceChildren();
        pageButtons = Array.from({ length: pageCount() }, (_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `Mostrar grupo ${index + 1} de ingredientes`);
          button.addEventListener('click', () => goToPage(index));
          pages.appendChild(button);
          return button;
        });
        paintActivePage(Math.min(activePage, pageCount() - 1));
      };
      const readScrollPosition = () => {
        if (!track) return;
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const maxScroll = Math.max(1, track.scrollWidth - track.clientWidth);
          paintActivePage(Math.round((track.scrollLeft / maxScroll) * (pageCount() - 1)));
        });
      };

      previous?.addEventListener('click', () => goToPage(activePage - 1));
      next?.addEventListener('click', () => goToPage(activePage + 1));
      track?.addEventListener('scroll', readScrollPosition, { passive: true });
      track?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goToPage(activePage + (event.key === 'ArrowRight' ? 1 : -1));
      });
      window.addEventListener('resize', () => {
        renderPages();
        goToPage(activePage, false);
      }, { passive: true });
      renderPages();
    }

    const reviews = root.querySelector('[data-fcp-reviews]');
    if (reviews) {
      const reviewTabs = Array.from(reviews.querySelectorAll('[data-fcp-review-tab]'));
      const reviewPanels = Array.from(reviews.querySelectorAll('[data-fcp-review-panel]'));
      const activateReviewTab = (tab) => {
        reviewTabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        reviewPanels.forEach((panel) => {
          panel.hidden = panel.dataset.fcpReviewPanel !== tab.dataset.fcpReviewTab;
        });
      };
      reviewTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateReviewTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + reviewTabs.length) % reviewTabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % reviewTabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = reviewTabs.length - 1;
          activateReviewTab(reviewTabs[nextIndex]);
          reviewTabs[nextIndex].focus();
        });
      });
      activateReviewTab(reviewTabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || reviewTabs[0]);

      const toggleDisclosure = (button, panel) => {
        if (!button || !panel) return;
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
        if (!open) panel.querySelector('button, input, select, textarea')?.focus();
      };
      const filterToggle = reviews.querySelector('[data-fcp-review-filter-toggle]');
      const filters = reviews.querySelector('#fcp-review-filters');
      filterToggle?.addEventListener('click', () => toggleDisclosure(filterToggle, filters));

      const formToggle = reviews.querySelector('[data-fcp-review-form-toggle]');
      const reviewForm = reviews.querySelector('[data-fcp-review-form]');
      formToggle?.addEventListener('click', () => toggleDisclosure(formToggle, reviewForm));

      const reviewCards = Array.from(reviews.querySelectorAll('[data-fcp-review-card]'));
      const reviewList = reviews.querySelector('[data-fcp-review-list]');
      const reviewCount = reviews.querySelector('[data-fcp-review-count]');
      const filterButtons = Array.from(reviews.querySelectorAll('[data-fcp-rating-filter]'));
      let activeRating = 'all';
      const applyReviewFilter = () => {
        let visible = 0;
        reviewCards.forEach((card) => {
          const showCard = activeRating === 'all' || card.dataset.rating === activeRating;
          card.hidden = !showCard;
          if (showCard) visible += 1;
        });
        if (reviewCount) reviewCount.textContent = `${visible} ${visible === 1 ? 'AVALIAÇÃO' : 'AVALIAÇÕES'}`;
      };
      filterButtons.forEach((button) => button.addEventListener('click', () => {
        activeRating = button.dataset.fcpRatingFilter || 'all';
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        applyReviewFilter();
      }));

      const sort = reviews.querySelector('[data-fcp-review-sort]');
      const sortReviewCards = () => {
        if (!reviewList || !sort) return;
        const sorted = [...reviewCards].sort((a, b) => {
          const ratingA = Number(a.dataset.rating || 0);
          const ratingB = Number(b.dataset.rating || 0);
          const orderA = Number(a.dataset.order || 0);
          const orderB = Number(b.dataset.order || 0);
          if (sort.value === 'rating-asc') return ratingA - ratingB || orderB - orderA;
          if (sort.value === 'newest') return orderB - orderA;
          return ratingB - ratingA || orderB - orderA;
        });
        sorted.forEach((card) => reviewList.appendChild(card));
      };
      sort?.addEventListener('change', sortReviewCards);

      reviewCards.forEach((card) => {
        const feedbackButtons = Array.from(card.querySelectorAll('[data-fcp-helpful], [data-fcp-unhelpful]'));
        feedbackButtons.forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', () => {
            const wasPressed = button.getAttribute('aria-pressed') === 'true';
            feedbackButtons.forEach((item) => {
              item.setAttribute('aria-pressed', 'false');
              const count = item.querySelector('b');
              if (count) count.textContent = '0';
            });
            if (!wasPressed) {
              button.setAttribute('aria-pressed', 'true');
              const count = button.querySelector('b');
              if (count) count.textContent = '1';
            }
          });
        });
      });

      reviewForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!reviewForm.reportValidity()) return;
        const status = reviewForm.querySelector('[data-fcp-review-form-status]');
        if (status) status.textContent = 'Formulário validado. A integração da loja fará o envio e a moderação.';
      });
    }

    const variantId = root.querySelector('[data-fcp-variant-id]');
    const sellingPlan = root.querySelector('[data-fcp-selling-plan]');
    const addLabel = root.querySelector('[data-fcp-add-label]');
    const supplyOptions = Array.from(root.querySelectorAll('[data-fcp-supply]'));
    const buyOnce = root.querySelector('[data-fcp-buy-once]');
    const selectSubscription = (radio) => {
      root.querySelectorAll('.fcp-supply__option').forEach((option) => option.classList.toggle('is-selected', option.contains(radio)));
      if (variantId) variantId.value = radio.dataset.variantId;
      if (sellingPlan) {
        sellingPlan.disabled = false;
        sellingPlan.value = radio.dataset.sellingPlanId;
      }
      if (addLabel) addLabel.textContent = `${radio.dataset.salePrice || radio.dataset.total} – ADICIONAR À SACOLA`;
      buyOnce?.classList.remove('is-selected');
    };
    supplyOptions.forEach((radio) => radio.addEventListener('change', () => selectSubscription(radio)));
    buyOnce?.addEventListener('click', () => {
      supplyOptions.forEach((radio) => { radio.checked = false; });
      root.querySelectorAll('.fcp-supply__option').forEach((option) => option.classList.remove('is-selected'));
      buyOnce.classList.add('is-selected');
      if (variantId) variantId.value = buyOnce.dataset.variantId;
      if (sellingPlan) sellingPlan.disabled = true;
      if (addLabel) addLabel.textContent = `${buyOnce.dataset.total} – ADICIONAR À SACOLA`;
    });

    const crossSell = root.querySelector('[data-fcp-cross-sell]');
    if (crossSell) {
      const form = crossSell.querySelector('[data-fcp-routine-form]');
      const addOns = Array.from(crossSell.querySelectorAll('[data-fcp-addon]'));
      const total = crossSell.querySelector('[data-fcp-routine-total]');
      const compare = crossSell.querySelector('[data-fcp-routine-compare]');
      const button = crossSell.querySelector('.fcp-routine__button');
      const buttonLabel = crossSell.querySelector('[data-fcp-routine-button-label]');
      const status = crossSell.querySelector('[data-fcp-routine-status]');
      const basePrice = Number(crossSell.dataset.basePrice || 0);
      const baseCompare = Number(crossSell.dataset.baseComparePrice || basePrice);
      const baseVariantId = Number(crossSell.dataset.baseVariantId || 0);
      const currency = window.Shopify?.currency?.active || 'BRL';
      const money = (cents) => new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);

      const renderCrossSell = () => {
        let selectedPrice = basePrice;
        let selectedCompare = baseCompare;
        addOns.forEach((addOn) => {
          const selected = addOn.checked && !addOn.disabled;
          selectedPrice += selected ? Number(addOn.dataset.price || 0) : 0;
          selectedCompare += selected ? Number(addOn.dataset.comparePrice || addOn.dataset.price || 0) : 0;
          crossSell.querySelector(`[data-fcp-addon-card="${addOn.value}"]`)?.classList.toggle('is-unselected', !selected);
        });
        if (total) total.textContent = money(selectedPrice);
        if (compare) {
          compare.textContent = money(selectedCompare);
          compare.hidden = selectedCompare <= selectedPrice;
        }
      };

      addOns.forEach((addOn) => {
        addOn.addEventListener('input', renderCrossSell);
        addOn.addEventListener('change', renderCrossSell);
      });
      renderCrossSell();

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!baseVariantId || button?.disabled) return;

        const items = [{ id: baseVariantId, quantity: 1 }];
        addOns.forEach((addOn) => {
          if (addOn.checked && !addOn.disabled) items.push({ id: Number(addOn.value), quantity: 1 });
        });

        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = 'Adicionando…';
        if (status) status.textContent = '';

        try {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error('Não foi possível adicionar o ritual.');
          window.location.assign(`${shopRoot}cart`);
        } catch (error) {
          if (status) status.textContent = error instanceof Error ? error.message : 'Não foi possível adicionar o ritual.';
          if (button) button.disabled = false;
          if (buttonLabel) buttonLabel.textContent = 'Adicionar ritual à sacola';
        }
      });
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-femme-product-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
